<template lang="pug">
	.campaign-detail.flex-col
		template(v-if="campaign")
			CampaignWizard(v-if="isWizardMode", :info="info", :items="menuItems.filter(f => (!f.hidden || !f.hidden()) && f.wizard !== false)", @change="v => activeMenuItem = v", :activeItemId="activeMenuItem"
				@finish="onWizardFinish")
			.flex-col
				.flex-row.justify.wrap.nav-header-wrapper(v-if="!isWizardMode")
					.flex-col.nav-header.justify
						.flex-row.space.justify
							.left.flex-row.space-large
								.flex-row.space.align-center
									a(@click="() => $router.push({ path: type === 1 ? '/campaign/List' : '/proposal/List' })") {{type === 1 ? $tCaption('Campaigns') : $tCaption('Proposals')}}
									.spacer /
									span.nowrap {{campaign.Name}}
									.clickable.flex-row.align-center.center(v-if="readonly", @click="readonly = false", :title="$tCaption('Remove readonly')")
										fas(icon="lock", size="2xs")
							.right.flex-row.space
								DxDropDownButton(v-if="actions.length", icon="more", :items="actions", stylingMode="filled",  display-expr="name", key-expr="id", :use-select-mode="false", :showArrowIcon="false", 
									:drop-down-options="{ width: 230 }", @item-click="onActionClick")
				.flex-row.padding
					NavigatorMenu(v-if="!isNew && !isWizardMode", :items="menuItems", @change="v => onActiveMenuItemChange(v)", :activeItemId="activeMenuItem")
					.right-side.flex-1.flex-col.lr-padding
						CampaignOverview(v-show="activeMenuItem === 'overview'", :info="info", @delete-campaign="deleteCampaign", @navigate="v => activeMenuItem = v")
						template(v-if="!isNew")
							CampaignProducts(v-show="activeMenuItem === 'products'", :info="info", @show-product="onShowProduct", @new-product="onNewProduct")
							CampaignProduct(v-show="activeProducts.length", :info="info", :products="activeProducts", @product-removed="onProductRemoved", @new-product="onNewProduct")
							CampaignCreatives(v-if="activated['creatives']", v-show="activeMenuItem === 'creatives'", :campaignId="campaign.Oid", :internal="true", :readonly="readonly")
							CampaignGeotargeting(v-if="activated['geotargeting']", v-show="activeMenuItem === 'geotargeting'", :info="info", ref="geotargeting", :mapPosition="mapState")
							CampaignGeotargetingAudience(v-if="activated['audience']", v-show="activeMenuItem === 'audience'", :info="info", :geoTargeting="campaign.JsonConfig.geoTargeting")
							ScheduleEditor(v-if="activated['ad-rotation']", v-show="activeMenuItem === 'ad-rotation'", tab="ad", :campaignId="campaign.Oid", :readonly="readonly")
							GeoFencingMap(v-if="activated['geofencing']", v-show="activeMenuItem === 'geofencing'", :data="geoFencing", :readonly="readonly", ref="geofencing", :mapPosition="mapState")
							CampaignBudget(v-show="activeMenuItem === 'budget'", :activated="activated['budget']", :info="info", ref="budget")
							CampaignStationsMap(v-show="activeMenuItem === 'stations'", :activated="activated['stations']", :info="info", ref="stations", :mapPosition="mapState")
		Loader(v-if="isLoading", :fullscreen="true")
		CampaignVastLink(ref="vastLink")
</template>

<script>
	import _ from 'lodash';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import Loader from 'app-core/Loader.vue';
	import Dropdown from 'app-core/Dropdown.vue';
	import moment from 'moment';
	import CampaignCreatives from './CampaignCreatives.vue';
	import ScheduleEditor from 'view/schedule/ScheduleEditor.vue';
	import NavigatorMenu from 'app-core/NavigatorMenu.vue';
	import CampaignOverview from './CampaignOverview.vue';
	import CampaignProducts from './CampaignProducts.vue';
	import { DAP_CATEGORY_TYPES } from 'app-core/constants';
	import CampaignProduct from './CampaignProduct.vue';	
	import GeoFencingMap from 'view/maps/GeoFencingMap.vue';
	import CampaignGeotargeting from './CampaignGeotargeting.vue';
	import CampaignGeotargetingAudience from './CampaignGeotargetingAudience.vue';
	import CampaignBudget from './CampaignBudget.vue';
	import CampaignStationsMap from './CampaignStationsMap.vue';
	import CampaignWizard from './CampaignWizard';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import CampaignVastLink from './CampaignVastLink.vue';

	export default {
		translationCategory: 'campaign.Detail',
		name: 'campaign-detail',
		components: {
			DxButton, DxTextBox, Loader, DxDateBox, Dropdown, DxDropDownButton,
			CampaignCreatives, ScheduleEditor, NavigatorMenu, CampaignOverview, CampaignProducts,
			CampaignProduct, GeoFencingMap, CampaignGeotargeting, CampaignGeotargetingAudience,
			CampaignBudget, CampaignStationsMap, CampaignWizard, CampaignVastLink
		},
		props: ['id', 'wizard'],
		data() {
			return {
				campaign: null,
				isLoading: false,
				states: {},
				isSaving: false,
				tab: 'creatives',
				activeMenuItem: 'overview',
				campaignProducts: [],
				dapCategoryTypes: DAP_CATEGORY_TYPES.toLocale('name', this),
				activated: {},
				geoFencing: { 
					geoFencingPoints: [],
					imageGeofencing: null
				},
				isWizardMode: this.wizard,
				readonly: null,
				mapState: {},
				countryConfig: null,
				countryConfigLoaded: false
			};
		},
		computed: {
			type() {
				return this.campaign?.CampaignType;
			},
			info() {
				return {
					campaign: this.campaign,
					campaignProducts: this.orderedCampaignProducts,
					states: this.states,
					isNew: this.isNew,
					readonly: this.readonly,
					fullAccess: this.fullAccess,
					wizard: this.isWizardMode,
					isLoading: this.isLoading,
					type: this.type,
					mapState: this.mapState,
					countryConfig: this.countryConfig,
					layoutGroups: this.layoutGoups,
					countryCode: this.countryCode,
					configLoaded: this.countryConfigLoaded
				}
			},
			menuItems() {
				return this.isNew ? 
					[{ id: 'overview', name: this.$tCaption('New campaign'), icon: 'circle-info' }]
					:
					[
						{ id: 'overview', name: this.isWizardMode ? this.$tCaption('Info') : this.$tCaption('Overview'), icon: 'circle-info' },
						{ id: 'products', name: this.$tCaption('Products'), icon: 'list', 
							subItems: this.wizard ? [] : this.orderedCampaignDapCategoriesProducts.map(f => ({ id: `product_${f.Oid}`, 
								name: f.Products?.length === 1 ? f.Products[0].Name : f.DapCategoryType.name, icon: f.DapCategoryType.icon, parent: 'products' })),
							hidden: () => !this.fullAccess,
							canNext: () => this.campaignProducts.length,
							hint: () => !this.campaignProducts.length ? this.$tCaption('Please select products to continue') : ''
						},
						{ id: 'stations', name:  this.$tCaption('Stations'), icon: 'tower-cell', hidden: () => !this.isStationsVisible || !this.fullAccess,
							canNext: () => !this.stationsIsRequiredAndNotFilled(),
							hint: () => this.stationsIsRequiredAndNotFilled() ? this.$tCaption('Please add stations') : ''
						},
						...(this.wizard ? this.orderedCampaignDapCategoriesProducts.map(f => ({ id: `product_${f.Oid}`, 
							name: f.Products?.length === 1 ? f.Products[0].Name : f.DapCategoryType.name, icon: f.DapCategoryType.icon })) : []),
						{ id: 'geotargeting', name: this.$tCaption('Geotargeting'), icon: 'globe', 
							subItems: this.campaign?.JsonConfig?.geoTargeting?.locations?.length ? [{ id: 'audience', name: this.$tCaption('Audience'), icon: 'users', parent: 'geotargeting' }] : null,
							hidden: () => !this.fullAccess,
							canNext: () => this.campaign?.JsonConfig?.geoTargeting?.locations?.length,
							hint: () => !this.campaign?.JsonConfig?.geoTargeting?.locations?.length ? this.$tCaption('Please select geotargeting') : ''
						},
						{ id: 'geofencing', name: this.$tCaption('Geofencing'), icon: 'location-dot', hidden: () => !this.fullAccess },
						{ id: 'creatives', name: this.$tCaption('Creatives'), icon: 'file-audio', 
							subItems: (this.type === 1 ? [{ id: 'ad-rotation', name:  this.$tCaption('Ad Rotation'), icon: 'refresh' }] : [])
						},
						{ id: 'budget', name:  this.$tCaption('Budget'), icon: 'dollar', hidden: () => !this.fullAccess },
					]
			},
			activeProducts() {
				return this.activeMenuItem.indexOf('product_') > -1 && this.orderedCampaignDapCategoriesProducts.find(f => `product_${f.Oid}` === this.activeMenuItem)?.Products || [];
			},
			orderedCampaignProducts() {
				return _.orderBy(this.campaignProducts, ['DapCategory.Type', 'Name']);
			},
			orderedCampaignDapCategoriesProducts() {
				const groups = _.groupBy(this.campaignProducts, v => v?.DapCategory?.Type);
				return Object.keys(groups).map(f => ({
					Oid: this.dapCategoryTypes[f]?.id,
					DapCategoryType: this.dapCategoryTypes[f],
					Products: groups[f]
				}));
			},
			isNew() {
				return !this.campaign?.Oid;
			},
			isStationsVisible() {
				return this.campaignProducts.some(f => f.type.components.airtime || [0,1].indexOf(f.type.id) > -1);
			},
			fullAccess() {
				return this.$auth.isAdmin() || this.type === 0;
			},
			layoutGoups() {
				if (!this.countryConfig?.layout) return [];

				let items = [];

				let getItems = (v, parent) => {
					if (!v) return;
					if (v.type === 'group') {
						items.push(v);
					} else {
						if (v?.items) {
							v.items.map(f => getItems(f, v));
						}
					}
				}

				getItems(this.countryConfig?.layout);

				return items;
			},
			countryCode() {
				return this.$auth.countryCode() || 'US';
			},
			actions() {
				return [
					{ id: 'vast', name: this.$tCaption('Get VAST Tag'), icon: 'fas fa-copy', hidden: this.type !== 1 },
				];
			}
		},
		watch: {
			campaign: {
				handler() {
					if (!this.isLoading && !this.isSaving) {
						if (__DEBUG__)
							console.debug('Campaign changed', arguments);
						this.$save();
					}
				},
				deep: true
			},
			'campaign.PopulationStatistic': {
				handler(v) {
					if (v) {
						v.NeedUpdate = true;
					}
				},
				deep: true
			},
			id(v) {
				if (!this.campaign || this.campaign.Oid !== v) {
					this.loadCampaign();
				}
			},
			activeMenuItem(v) {
				this.$set(this.activated, v, true);
			},
			'geoFencing.geoFencingPoints': {
				handler(v) {
					this.$set(this.campaign.JsonConfig, 'geoFencing', {
						locations: v
					});
				},
				deep: true
			},
			'geoFencing.imageGeofencing'(v) {
				if (v)
					this.updateCampaignImage('ImageGeofencing', v);
			}
		},
		mounted() {
			if (__DEBUG__)
				window.campaign = this;
			this.loadCampaign();

			this.$save = _.debounce(this.save, 1000, {
				'leading': false,
				'trailing': true
			});

			this.loadCountryConfig();
		},
		destroyed() {
			delete this.$save;
		},
		methods: {
			onActionClick(e) {
				switch(e.itemData.id) {
					case 'vast':
						this.$refs.vastLink.open(this.campaign?.Oid);
						break;
				}
			},
			async loadCountryConfig() {
				this.isLoading++;
				this.countryConfigLoaded = false;
				let countryInfo = (await this.$Data.getExternalApi('Country/List', `page=1&page={page}&filterCriteria=['Code', '=', '${this.countryCode}']`, 1).finally(() => {
					this.isLoading--;
					this.countryConfigLoaded = true;
				}))?.Results[0];

				if (__DEBUG__)
					console.debug('Load config', { countryInfo });
				
				this.countryConfig = countryInfo?.JsonConfig?.zipConfig;
			},
			onActiveMenuItemChange(v) {
				this.storeMapPosition();
				this.activeMenuItem = v;
				setTimeout(() => {
					if (this._isDestroyed) return;
					this.restoreMapPosition();
				}, 100);
			},
			getActiveMap() {
				let activeItem = this.$refs[this.activeMenuItem];
				let map = 
					activeItem?.$refs?.cartoMap?.$map
					|| activeItem?.$map
					|| activeItem?.$refs?.selector?.$refs?.map?.$map
					|| activeItem?.$refs?.map?.$map;

				return map;
			},
			storeMapPosition() {
				let map = this.getActiveMap();

				if (map) {
					if (__DEBUG__)
						console.debug('Store map position');

					this.mapState = {
						...map.getCenter(),
						zoom: map.getZoom()
					}
				}
			},
			restoreMapPosition() {
				let map = this.getActiveMap();

				if (map && this.mapState) {
					if (__DEBUG__)
						console.debug('Restore map position');

					map.setView([this.mapState.lat, this.mapState.lng], this.mapState.zoom);
				}
			},
			onWizardFinish() {
				this.isWizardMode = false;
				this.activeMenuItem = 'overview';
			},
			stationsIsRequiredAndNotFilled() {
				return this.campaignProducts.some(f => f.type.components.airtime) && !this.campaign.Stations?.length;
			},
			updateCampaignImage(fieldName, dataUri) {
				return this.$Data.postExternalApi('Service/SetObjectImage', {
					ObjectId: this.campaign.Oid,
					FieldName: fieldName,
					ObjectType: 13,
					FileExtension: '.jpg',
					Base64Content: dataUri?.split(';base64,')[1]
				}).then(r => {
					if (r?.Data?.AzureFileUrl) {
						this.$set(this.campaign, `${fieldName}Url`, r?.Data?.AzureFileUrl);
					}
					return r;
				});
			},
			onProductRemoved(product) {
				let productIndex = this.orderedCampaignProducts.findIndex(f => f.Oid === product.Oid);
				let removeIndex = this.campaignProducts.findIndex(f => f.Oid === product.Oid);
				if (productIndex > -1) {
					this.campaignProducts.splice(removeIndex, 1);
					this.recalcBudget();
				}
				if (productIndex > this.campaignProducts.length - 1) {
					productIndex = this.campaignProducts.length - 1;
				}
				if (this.orderedCampaignProducts.length) {
					this.activeMenuItem = `product_${this.orderedCampaignProducts[productIndex].type.id}`;
				} else {
					this.activeMenuItem = 'products';
				}
			},
			onShowProduct(product) {
				this.activeMenuItem = `product_${product.Oid}`;
			},
			onNewProduct(dapCategory) {
				if (__DEBUG__)
					console.debug('OnNewProduct', { dapCategory });
				
				this.$set(this.states, 'productsLoading', true);
				this.isLoading++;
				this.$Data.postExternalApi('CampaignProduct/CreateUpdateCampaignProduct', {
					Name: dapCategory.Name,
					DapCategory: dapCategory,
					CampaignId: this.id
				}).then(r => {
					if (r?.Data)
						this.campaignProducts.push(this.processLoadedProduct(r.Data));
				}).finally(() => {
					this.$set(this.states, 'productsLoading', false);
					this.isLoading--;
				});
			},
			setNew() {
				this.campaign = {
					Oid: null,
					Name: null,
					StartDate: null,
					EndDate: null,
					Advertiser: { Oid: this.$auth.isAdvertiser() ? this.$auth.companyId() : null },
					Agency: { Oid: this.$auth.isAgency() ? this.$auth.companyId() : null },
					CampaignType: 1
				};
			},
			loadCampaign() {
				if (!this.id || `${this.id}`.toLowerCase() === 'new') {
					this.setNew();
				} else {
					this.isLoading++;
					return this.$Data.getExternalCampaign(this.id).then((r) => this.processCampaignResult(r)).finally(() => {
						this.isLoading--;
						this.loadProducts();
					});
				}
			},
			processLoadedProduct(product) {
				return {
					...product,
					type: this.dapCategoryTypes[product.DapCategory.Type]
				}
			},
			loadProducts() {
				this.isLoading++;
				return this.$Data.getCampaignProducts(0, void 0, 999, this.id).then(async r => {
					this.campaignProducts = r.Results.map(f => this.processLoadedProduct(f));
					this.$forceUpdate();
				}).finally(() => this.isLoading--);
			},
			processCampaignResult(r) {
				if (!r) return;
				this.isLoading++;
				if (this.campaign && !this.campaign.Oid && r.Oid) {
					this.$notifySuccess(this.$tCaption('Campaign created'));
					this.$router.push({ path: `/campaign/Detail/${r.Oid}` });
				}
				if (__DEBUG__)
					console.debug('Process campaign result');
				this.campaign = _.assignWith(this.campaign || {}, r, (oldVal, newVal) => oldVal == null ? newVal : oldVal);
				this.campaign.__updateCampaignImage = this.updateCampaignImage;
				this.campaign.__recalcBudget = this.recalcBudget;
				this.geoFencing.geoFencingPoints = this.campaign.JsonConfig?.geoFencing?.locations || [];

				if (this.readonly == null) {
					this.readonly = this.$auth.isAdmin() && this.type === 1;
				}

				if (!this.campaign.Advertiser) this.campaign.Advertiser = { Oid: null };
				if (!this.campaign.Agency) this.campaign.Agency = { Oid: null };
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.isLoading--;
				});
			},
			recalcBudget() {
				this.$refs.budget.loadCampaignBudgets().then(r => {
					r.map(budget => this.$refs.budget.calcBudget(budget));
				});
			},
			save() {
				if (this.isSaving || this.isLoading || this._isDestroyed) return;
				if (__DEBUG__)
					console.debug('Saving', this.isSaving);
				
				if (this.campaign.Oid || (this.campaign.Name && this.campaign.StartDate && this.campaign.EndDate && this.campaign.Agency.Oid && this.campaign.Advertiser.Oid)) {
					this.isSaving = true;
					if (!this.campaign.Oid)
						this.isLoading = true;
					return this.$Data.postExternalApi('Campaign/CreateUpdateCampaign', { 
						...this.campaign,
						StartDate: moment(this.campaign.StartDate).clone().startOf('day').format('YYYY-MM-DDTHH:mm:ss'),
						EndDate: moment(this.campaign.EndDate).clone().endOf('day').format('YYYY-MM-DDTHH:mm:ss')
					}).then(r => {
						if (this._isDestroyed) return;
						if (!this.campaign.Oid)
							this.isLoading = false;
						if (r.Success) {
							this.processCampaignResult(r.Data);
						} else {
							this.$notifyError(r.ErrorMessage);
						}
					}).finally(() => {
						this.isSaving = false;
					}).catch(() => {
						if (!this.campaign.Oid)
							this.isLoading = false;
					});
				}
			},
			deleteCampaign() {
				this.$confirmMessage({
					title: () => this.$tCaption('Confirm action', '@actions'),
					text: this.type === 1 ? this.$tCaption('Are you sure you want to delete campaign?') : this.$tCaption('Are you sure you want to delete proposal?'),
					handler: () => {
						this.isLoading = true;
						this.$Data.getExternalApi('Campaign/DeleteCampaign', `campaignId=${this.campaign.Oid}`).then(r => {
							if (r.Success) {
								if (this.type === 1) {
									this.$notifySuccess(this.$tCaption('Campaign deleted'));
									this.$router.push({ path: '/campaign/List' });
								} else {
									this.$notifySuccess(this.$tCaption('Proposal deleted'));
									this.$router.push({ path: '/proposal/List' });
								}
							} else {
								this.$notifyError(r.ErrorMessage);
							}
						}).finally(() => {
							if (this._isDestroyed) return;
							this.isLoading = false;
						});
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.campaign-detail {
		.header-data {
			margin: 10px;
		}

		.left-items {
			min-width: 340px;
		}

		.edit {
			margin-left: 20px;
		}
		
		.buttons-group {
			.dx-button {
				border-radius: 0px !important;

				&.dx-button-default {
					border-bottom: 2px solid !important;
				}
			}
		}

		.area {
			position: relative;
			padding: 20px;
			background: rgb(237,237,237);
			border-radius: 4px;

			&:hover {
				.link-icon {
					color: $base-accent;
				}
			}
		}

		.clickable-area {
			cursor: pointer;
			transition: 0.3s;
			transform: scale(1);
			font-weight: 400;
			
			&:hover {
				transform: scale(1.015);
				background: rgb(230,230,230);
				z-index: 1000;
			}

		}
		
		.link-area {			
			color: rgba(0,0,0,0.5);

			&.green {
				background: #bce4c3;
			}

			&.blue {
				background: #bcc2e4;
			}

			&.grey {
				background: #e8e8e8;
			}

			&.red {
				background: #e4bcbc;
			}
		}

		.link-icon {
			position: absolute;
			right: 10px;
			top: 10px;
			pointer-events: none;
			color: rgba(0,0,0,0.1);
		}

		.disabled {
			pointer-events: none;
			opacity: 0.55;
		}

		.tab-content {
			background: #f9f9f9;
			border-radius: 0px 6px 6px 6px;
			padding: 8px;
		}

		.tab-title {
			background: #f9f9f9;
			padding: 6px 12px;
			border-radius: 6px 6px 0px 0px;
		}

		.link-greyed {
			color: rgba(0,0,0,0.65);
		}

		.align-right-editors {
			.dx-numberbox .dx-texteditor-input {
				text-align: right !important;
			}
		}
	}
</style>
 